export const WORKSTREAMS = [
    { id: 'it', name: 'Information Technology', short: 'IT', irlCount: 9, obsCount: 8 },
    { id: 'cyber', name: 'Cybersecurity', short: 'Cybersecurity', irlCount: 5, obsCount: 5 },
    { id: 'commercial', name: 'Commercial', short: 'Commercial', irlCount: 4, obsCount: 4 },
];

export const OWNERS = ['Sarah Jones', 'Mark Taylor', 'James Patel'];

export const IRL_STATUS_FILTERS = ['All', 'Open', 'In progress', 'Responded', 'Needs review', 'Closed', 'Overdue'];

export const OBS_STATUS_FILTERS = ['All', 'Confirmed', 'Draft', 'Resolved', 'Superseded', 'New evidence', 'Review required'];

export const IRL_REQUESTS = [
    {
        id: 'IRL-042',
        title: 'Provide the latest infrastructure migration plan',
        workstream: 'IT',
        workstreamId: 'it',
        workstreamName: 'Information Technology',
        priority: 'High',
        owner: 'Sarah Jones',
        respondent: 'Acme Technology',
        due: '12 Oct',
        dueOverdue: false,
        status: 'Responded',
        freshness: 'New evidence',
        evidenceCount: 3,
        comments: 8,
        newComments: 2,
        created: '11 Jan 2025 · Sarah Jones',
        context:
            'Please provide the most recent version of the infrastructure migration plan, including cutover dates, dependencies, and any outstanding approvals. Where a finalised plan is not available, provide the current draft together with an explanation of the approval status.',
        followUps: [{ id: 'IRL-087', title: 'Provide the most recent completed DR test report, including recovery results' }],
        linkedObservations: [
            { id: 'OBS-018', title: 'Architecture knowledge remains concentrated in two senior engineers' },
            { id: 'OBS-019', title: 'Disaster recovery testing has not been performed within the required annual window' },
        ],
        response: {
            version: 'v3',
            current: true,
            body: 'The infrastructure migration plan was finalised in March 2026. The programme is structured across three phases with Phase 1 (network layer) complete. Phase 2 (compute migration) is in progress, scheduled for December 2026. Phase 3 (data tier) is planned for Q1 2027.',
            submittedBy: 'Sarah Jones',
            submittedOn: '21 Mar 2026',
            evidence: [
                { name: 'Migration Plan v3.pdf', path: 'IT → Infrastructure & Cloud', ready: true },
                { name: 'Architecture Overview.pdf', path: 'IT → Application Architecture', ready: true },
            ],
            history: [
                {
                    version: 'v3',
                    label: 'Current',
                    date: '21 Mar 2026',
                    by: 'Sarah Jones',
                    response_text:
                        'The infrastructure migration plan was finalised in March 2026. The programme is structured across three phases with Phase 1 (network layer) complete. Phase 2 (compute migration) is in progress, scheduled for December 2026. Phase 3 (data tier) is planned for Q1 2027.',
                },
                { version: 'v2', date: '14 Jun 2025', by: 'Mark Taylor', response_text: 'Migration plan v2 was submitted while Phase 1 was still in progress.' },
                { version: 'v1', date: '11 Jan 2025', by: 'Sarah Jones', response_text: 'An initial draft of the infrastructure migration plan was provided.' },
            ],
        },
        evidenceAlert: {
            title: 'New evidence may affect this response',
            body: 'Migration Plan v3 became Ready after Response v2 was submitted. Current response remains unchanged.',
        },
        evidence: [
            { name: 'Migration Plan v3.pdf', path: 'IT → Infrastructure & Cloud', date: '20 Mar 2026', ready: true },
            { name: 'Architecture Overview.pdf', path: 'IT → Application Architecture', date: '18 Jul 2025', ready: true },
            { name: 'SLA Schedule Q4.pdf', path: 'IT → Vendor Management', date: '12 Oct 2025', ready: true },
        ],
        history: [
            { date: '11 Jan 2025', title: 'IRL created', detail: 'by Sarah Jones' },
            { date: '14 Jan 2025', title: 'Response v1 submitted', detail: 'by Acme Technology' },
            { date: '15 Jan 2025', title: 'Response reviewed', detail: 'by Mark Taylor' },
            { date: '20 Mar 2025', title: 'New evidence became available', detail: 'Migration Plan v2' },
            { date: '21 Mar 2025', title: 'AI Review run', detail: 'by Sarah Jones' },
            { date: '21 Mar 2025', title: 'Response v2 confirmed', detail: 'by Mark Taylor' },
            { date: '13 Jun 2025', title: 'IRL reopened', detail: 'by Sarah Jones — new evidence available' },
            { date: '15 Jun 2025', title: 'Follow-up IRL-087 created', detail: 'by Sarah Jones' },
            { date: '21 Mar 2026', title: 'Response v3 submitted', detail: 'by Sarah Jones' },
        ],
        discussion: [
            {
                id: 1,
                author: 'Sarah Jones',
                initials: 'SJ',
                time: '09:14',
                body: "The response mentions the migration plan, but I don't think we have the revised June version yet.",
                replies: [
                    { author: 'Mark Taylor', initials: 'MT', time: '09:22', body: "Agreed. I've asked the infrastructure team for it." },
                    { author: 'Sarah Jones', initials: 'SJ', time: '10:03', body: 'Once it arrives we should rerun the IRL review.' },
                ],
            },
            {
                id: 2,
                author: 'Mark Taylor',
                initials: 'MT',
                time: '14:46',
                body: 'Uploaded now. @Sarah Jones can you take another look?',
            },
        ],
        discussionEvent: 'Mark Taylor uploaded Migration Plan v3 · 14:42',
        discussionCount: 2,
    },
    {
        id: 'IRL-043',
        title: 'Confirm approved technology transformation budget',
        workstream: 'IT',
        workstreamId: 'it',
        workstreamName: 'Information Technology',
        priority: 'High',
        owner: 'Mark Taylor',
        respondent: 'Acme Technology',
        due: '15 Oct',
        dueOverdue: false,
        status: 'Needs review',
        freshness: 'Review required',
        evidenceCount: 2,
        comments: 3,
        created: '8 Jan 2025 · Mark Taylor',
        context: 'Confirm the approved technology transformation budget, including any staged releases and remaining unallocated contingency.',
        followUps: [],
        linkedObservations: [{ id: 'OBS-023', title: 'Technology transformation budget approval is pending board ratification' }],
        discussionCount: 3,
        evidence: [
            { name: 'Budget Pack FY26.pdf', path: 'IT → Finance', date: '2 Oct 2026', ready: true },
            { name: 'Board Minutes Sep.pdf', path: 'IT → Governance', date: '28 Sep 2026', ready: true },
        ],
        history: [{ date: '8 Jan 2025', title: 'IRL created', detail: 'by Mark Taylor' }],
        discussion: [],
    },
    {
        id: 'IRL-044',
        title: 'Provide evidence of DR testing performed within the last 12 months',
        workstream: 'IT',
        workstreamId: 'it',
        workstreamName: 'Information Technology',
        priority: 'High',
        owner: 'Sarah Jones',
        respondent: 'Acme Technology',
        due: '8 Oct',
        dueDate: '2026-10-08',
        dueOverdue: true,
        status: 'Open',
        workflowStatus: 'OPEN',
        freshness: null,
        evidenceCount: 0,
        comments: 1,
        created: '11 Jan 2025 · Sarah Jones',
        context:
            'Please provide the most recent version of the infrastructure migration plan, including cutover dates, dependencies, and any outstanding approvals. Where a finalised plan is not available, provide the current draft together with an explanation of the approval status.',
        followUps: [],
        linkedObservations: [{ id: 'OBS-019', title: 'Disaster recovery testing has not been performed within the required annual window' }],
        discussionCount: 0,
        evidence: [],
        history: [{ date: '11 Jan 2025', title: 'IRL created', detail: 'by Sarah Jones' }],
        discussion: [],
    },
    {
        id: 'IRL-045',
        title: "Describe the organisation's cloud hosting strategy",
        workstream: 'IT',
        workstreamId: 'it',
        workstreamName: 'Information Technology',
        priority: 'Medium',
        owner: 'James Patel',
        respondent: 'Acme Technology',
        due: '20 Oct',
        dueOverdue: false,
        status: 'In progress',
        freshness: null,
        evidenceCount: 1,
        comments: 4,
        created: '20 Jan 2025 · James Patel',
        context: 'Describe current cloud hosting strategy, including vendors, regions, and any planned migrations.',
        followUps: [],
        linkedObservations: [],
        discussionCount: 4,
        evidence: [{ name: 'Cloud Strategy Draft.pdf', path: 'IT → Infrastructure & Cloud', date: '4 Oct 2026', ready: true }],
        history: [{ date: '20 Jan 2025', title: 'IRL created', detail: 'by James Patel' }],
        discussion: [],
        response: {
            version: 'v1',
            current: true,
            body: 'Draft response in progress. Cloud hosting is primarily Azure with a secondary AWS analytics region.',
            submittedBy: 'James Patel',
            submittedOn: '4 Oct 2026',
            evidence: [{ name: 'Cloud Strategy Draft.pdf', path: 'IT → Infrastructure & Cloud', ready: true }],
            history: [{ version: 'v1', label: 'Draft', date: '4 Oct 2026', by: 'James Patel' }],
        },
    },
    {
        id: 'IRL-046',
        title: 'Provide the current vendor contracts and SLA schedules',
        workstream: 'IT',
        workstreamId: 'it',
        workstreamName: 'Information Technology',
        priority: 'Medium',
        owner: 'Sarah Jones',
        respondent: 'Acme Technology',
        due: '25 Oct',
        dueOverdue: false,
        status: 'Closed',
        freshness: 'New evidence',
        evidenceCount: 5,
        comments: 12,
        newComments: 3,
        created: '3 Feb 2025 · Sarah Jones',
        context: 'Provide current vendor contracts and associated SLA schedules for material technology vendors.',
        followUps: [],
        linkedObservations: [{ id: 'OBS-021', title: 'Vendor contracts include automatic annual price escalation clauses not disclosed in the IM' }],
        discussionCount: 12,
        evidence: [{ name: 'Vendor SLA Pack.pdf', path: 'IT → Vendor Management', date: '12 Oct 2025', ready: true }],
        history: [{ date: '3 Feb 2025', title: 'IRL created', detail: 'by Sarah Jones' }],
        discussion: [],
        response: {
            version: 'v1',
            current: true,
            body: 'Vendor contracts and SLA schedules were provided in the Vendor SLA Pack. Annual indexation clauses apply to three material vendors.',
            submittedBy: 'Sarah Jones',
            submittedOn: '12 Oct 2025',
            evidence: [{ name: 'Vendor SLA Pack.pdf', path: 'IT → Vendor Management', ready: true }],
            history: [{ version: 'v1', label: 'Current', date: '12 Oct 2025', by: 'Sarah Jones' }],
        },
        evidenceAlert: {
            title: 'New evidence may affect this response',
            body: 'Migration Plan v3 became Ready after current response was submitted.',
        },
    },
    {
        id: 'IRL-047',
        title: 'Confirm data residency requirements and compliance posture',
        workstream: 'Cybersecurity',
        workstreamId: 'cyber',
        workstreamName: 'Cybersecurity',
        priority: 'High',
        owner: 'Mark Taylor',
        respondent: 'Acme Technology',
        due: '11 Oct',
        dueOverdue: false,
        status: 'Responded',
        freshness: null,
        evidenceCount: 2,
        comments: 2,
        created: '12 Feb 2025 · Mark Taylor',
        context: 'Confirm data residency requirements and the organisation’s current compliance posture.',
        followUps: [],
        linkedObservations: [],
        discussionCount: 2,
        evidence: [{ name: 'Architecture Overview.pdf', path: 'IT → Application Architecture', date: '18 Jul 2025', ready: true }],
        history: [{ date: '12 Feb 2025', title: 'IRL created', detail: 'by Mark Taylor' }],
        discussion: [],
        response: {
            version: 'v1',
            current: true,
            body: 'Data is held in Ireland under GDPR compliant arrangements.',
            submittedBy: 'Mark Taylor',
            submittedOn: '10 Oct 2026',
            evidence: [{ name: 'Architecture Overview.pdf', path: 'IT → Application Architecture', ready: true }],
            history: [{ version: 'v1', label: 'Current', date: '10 Oct 2026', by: 'Mark Taylor' }],
        },
    },
    {
        id: 'IRL-048',
        title: 'Provide penetration test results from the last 24 months',
        workstream: 'Cybersecurity',
        workstreamId: 'cyber',
        workstreamName: 'Cybersecurity',
        priority: 'High',
        owner: 'Sarah Jones',
        respondent: 'Acme Technology',
        due: '9 Oct',
        dueDate: '2026-10-09',
        dueOverdue: true,
        status: 'Open',
        workflowStatus: 'OPEN',
        freshness: null,
        evidenceCount: 0,
        comments: 0,
        created: '1 Mar 2025 · Sarah Jones',
        context: 'Provide penetration test results covering the last 24 months, including remediations.',
        followUps: [],
        linkedObservations: [],
        discussionCount: 0,
        evidence: [],
        history: [{ date: '1 Mar 2025', title: 'IRL created', detail: 'by Sarah Jones' }],
        discussion: [],
    },
    {
        id: 'IRL-049',
        title: 'Describe integration dependencies with the parent ERP platform',
        workstream: 'IT',
        workstreamId: 'it',
        workstreamName: 'Information Technology',
        priority: 'Low',
        owner: 'James Patel',
        respondent: 'Acme Technology',
        due: '28 Oct',
        dueOverdue: false,
        status: 'Draft',
        freshness: null,
        evidenceCount: 0,
        comments: 0,
        created: '4 Mar 2025 · James Patel',
        context: 'Describe integration dependencies with the parent ERP platform.',
        followUps: [],
        linkedObservations: [],
        discussionCount: 0,
        evidence: [],
        history: [{ date: '4 Mar 2025', title: 'IRL created', detail: 'by James Patel' }],
        discussion: [],
    },
    {
        id: 'IRL-087',
        title: 'Provide the most recent completed DR test report, including recovery results',
        workstream: 'IT',
        workstreamId: 'it',
        workstreamName: 'Information Technology',
        priority: 'High',
        owner: 'Sarah Jones',
        respondent: 'Acme Technology',
        due: '18 Oct',
        dueOverdue: false,
        status: 'Open',
        freshness: null,
        evidenceCount: 0,
        comments: 1,
        followUpOf: 'IRL-042',
        created: '15 Jun 2025 · Sarah Jones',
        context: 'Follow-up to IRL-042. Provide the most recent completed DR test report, including recovery results.',
        followUps: [],
        linkedObservations: [],
        discussionCount: 1,
        evidence: [],
        history: [{ date: '15 Jun 2025', title: 'Follow-up IRL created', detail: 'by Sarah Jones' }],
        discussion: [],
    },
];

export const OBSERVATIONS = [
    {
        id: 'OBS-018',
        title: 'Architecture knowledge remains concentrated in two senior engineers',
        workstream: 'IT',
        workstreamId: 'it',
        workstreamName: 'Information Technology',
        materiality: 'High',
        status: 'Confirmed',
        freshness: 'New evidence',
        updated: '29 Sep',
        sources: 4,
        comments: 12,
        newComments: 3,
        discussionCount: 2,
        body: 'Architecture knowledge remains concentrated in two senior engineers. No succession planning or documentation programme is in place.',
        confirmedBy: 'Mark Taylor',
        confirmedOn: '14 Jun 2026',
        revisions: [
            { version: 2, date: '14 Jun 2026', by: 'Mark Taylor' },
            { version: 1, date: '11 Jan 2026', by: 'Sarah Jones' },
        ],
        evidenceAlert: {
            title: 'New evidence may affect this observation',
            body: 'Updated team structure evidence became available after Revision 2. Current Observation remains unchanged.',
        },
        evidence: [
            { name: 'Org Chart v4.pdf', path: 'IT → People', date: '20 Sep 2026', ready: true },
            { name: 'Architecture Overview.pdf', path: 'IT → Application Architecture', date: '18 Jul 2025', ready: true },
        ],
        relatedIrls: [{ id: 'IRL-042', title: 'Provide the latest infrastructure migration plan' }],
        history: [
            { date: '11 Jan 2026', title: 'Observation created', detail: 'by Sarah Jones' },
            { date: '14 Jun 2026', title: 'Revision 2 confirmed', detail: 'by Mark Taylor' },
            { date: '20 Sep 2026', title: 'New evidence became available', detail: 'Org Chart v4' },
        ],
        discussion: [
            {
                id: 1,
                author: 'Sarah Jones',
                initials: 'SJ',
                time: '11:02',
                body: 'The org chart update does not change the key-person concentration.',
                replies: [],
            },
        ],
        discussionEvent: null,
    },
    {
        id: 'OBS-019',
        title: 'Disaster recovery testing has not been performed within the required annual window',
        workstream: 'IT',
        workstreamId: 'it',
        workstreamName: 'Information Technology',
        materiality: 'High',
        status: 'Confirmed',
        freshness: null,
        updated: '21 Sep',
        sources: 3,
        comments: 5,
        discussionCount: 1,
        body: 'The most recent completed recovery test located is dated September 2023, outside the required annual window.',
        confirmedBy: 'Sarah Jones',
        confirmedOn: '21 Sep 2026',
        revisions: [{ version: 1, date: '21 Sep 2026', by: 'Sarah Jones' }],
        evidence: [{ name: 'DR Test 2023.pdf', path: 'IT → Resilience', date: 'Sep 2023', ready: true }],
        relatedIrls: [{ id: 'IRL-044', title: 'Provide evidence of DR testing performed within the last 12 months' }],
        history: [{ date: '21 Sep 2026', title: 'Observation confirmed', detail: 'by Sarah Jones' }],
        discussion: [],
    },
    {
        id: 'OBS-020',
        title: 'Cloud migration roadmap lacks confirmed cutover dates for three critical workloads',
        workstream: 'IT',
        workstreamId: 'it',
        workstreamName: 'Information Technology',
        materiality: 'Medium',
        status: 'Confirmed',
        freshness: null,
        updated: '15 Sep',
        sources: 2,
        comments: 7,
        discussionCount: 0,
        body: 'Three critical workloads do not have confirmed cutover dates in the current cloud migration roadmap.',
        confirmedBy: 'James Patel',
        confirmedOn: '15 Sep 2026',
        revisions: [{ version: 1, date: '15 Sep 2026', by: 'James Patel' }],
        evidence: [],
        relatedIrls: [{ id: 'IRL-045', title: "Describe the organisation's cloud hosting strategy" }],
        history: [{ date: '15 Sep 2026', title: 'Observation confirmed', detail: 'by James Patel' }],
        discussion: [],
    },
    {
        id: 'OBS-021',
        title: 'Vendor contracts include automatic annual price escalation clauses not disclosed in the IM',
        workstream: 'Commercial',
        workstreamId: 'commercial',
        workstreamName: 'Commercial',
        materiality: 'High',
        status: 'Confirmed',
        freshness: 'Review required',
        updated: '12 Sep',
        sources: 5,
        comments: 3,
        discussionCount: 0,
        body: 'Material vendor contracts include automatic annual price escalation that was not disclosed in the information memorandum.',
        confirmedBy: 'Sarah Jones',
        confirmedOn: '12 Sep 2026',
        revisions: [{ version: 1, date: '12 Sep 2026', by: 'Sarah Jones' }],
        evidence: [{ name: 'Vendor SLA Pack.pdf', path: 'IT → Vendor Management', date: '12 Oct 2025', ready: true }],
        relatedIrls: [{ id: 'IRL-046', title: 'Provide the current vendor contracts and SLA schedules' }],
        history: [{ date: '12 Sep 2026', title: 'Observation confirmed', detail: 'by Sarah Jones' }],
        discussion: [],
    },
    {
        id: 'OBS-022',
        title: 'Privileged access management controls are not consistently enforced across legacy systems',
        workstream: 'Cybersecurity',
        workstreamId: 'cyber',
        workstreamName: 'Cybersecurity',
        materiality: 'High',
        status: 'Confirmed',
        freshness: null,
        updated: '8 Sep',
        sources: 3,
        comments: 4,
        discussionCount: 0,
        body: 'Privileged access management is not consistently enforced on legacy systems that remain in production.',
        confirmedBy: 'Mark Taylor',
        confirmedOn: '8 Sep 2026',
        revisions: [{ version: 1, date: '8 Sep 2026', by: 'Mark Taylor' }],
        evidence: [],
        relatedIrls: [],
        history: [{ date: '8 Sep 2026', title: 'Observation confirmed', detail: 'by Mark Taylor' }],
        discussion: [],
    },
    {
        id: 'OBS-023',
        title: 'Technology transformation budget approval is pending board ratification',
        workstream: 'IT',
        workstreamId: 'it',
        workstreamName: 'Information Technology',
        materiality: 'Medium',
        status: 'Resolved',
        freshness: null,
        updated: '3 Sep',
        sources: 2,
        comments: 6,
        discussionCount: 0,
        body: 'Board ratification of the technology transformation budget was outstanding at the time of review and has since been completed.',
        confirmedBy: 'Mark Taylor',
        confirmedOn: '3 Sep 2026',
        revisions: [{ version: 1, date: '3 Sep 2026', by: 'Mark Taylor' }],
        evidence: [],
        relatedIrls: [{ id: 'IRL-043', title: 'Confirm approved technology transformation budget' }],
        history: [{ date: '3 Sep 2026', title: 'Observation resolved', detail: 'by Mark Taylor' }],
        discussion: [],
    },
    {
        id: 'OBS-024',
        title: 'Third-party SLA reporting is inconsistent with contractual requirements',
        workstream: 'IT',
        workstreamId: 'it',
        workstreamName: 'Information Technology',
        materiality: 'Low',
        status: 'Draft',
        freshness: null,
        updated: '1 Oct',
        sources: 1,
        comments: 0,
        discussionCount: 0,
        body: 'SLA reporting from two third-party vendors does not match the frequency required in the contracts.',
        confirmedBy: null,
        confirmedOn: null,
        revisions: [{ version: 1, date: '1 Oct 2026', by: 'Sarah Jones' }],
        evidence: [],
        relatedIrls: [],
        history: [{ date: '1 Oct 2026', title: 'Draft created', detail: 'by Sarah Jones' }],
        discussion: [],
    },
];

export const REVIEW_AFFECTED_IRLS = [
    {
        id: 'IRL-042',
        title: 'Provide the latest infrastructure migration plan',
        freshness: 'New evidence',
        whatChanged: 'Migration Plan v3 became Ready after current response was submitted.',
    },
    {
        id: 'IRL-046',
        title: 'Provide the current vendor contracts and SLA schedules',
        freshness: 'New evidence',
        whatChanged: 'Migration Plan v3 became Ready after current response was submitted.',
    },
];

export const REVIEW_AFFECTED_OBS = [
    {
        id: 'OBS-018',
        title: 'Architecture knowledge remains concentrated in two senior engineers',
        freshness: 'New evidence',
        whatChanged: 'Updated evidence became Ready after the current revision was confirmed.',
    },
    {
        id: 'OBS-021',
        title: 'Vendor contracts include automatic annual price escalation clauses not disclosed in the IM',
        freshness: 'Potentially affected',
        whatChanged: 'Updated evidence became Ready after the current revision was confirmed.',
    },
];

export const AI_REVIEW_MODES = [
    {
        id: 'responses',
        title: 'Review responses & suggest Observations',
        description: 'Analyse IRL questions, responses and Ready attachments to identify material observations for human review.',
    },
    {
        id: 'gaps',
        title: 'Find gaps & suggest follow-up requests',
        description: 'Find incomplete, unsupported, ambiguous or contradictory responses and recommend new or follow-up IRLs.',
    },
    {
        id: 'answers',
        title: 'Find answers to open requests',
        description: 'Search authorised project evidence for evidence that may answer open IRLs and draft responses with citations.',
    },
    {
        id: 'full',
        title: 'Full IRL review',
        description: 'Run all of the above in one review.',
    },
    {
        id: 'initial',
        title: 'Scan VDR to create initial IRL',
        description: 'Scan the virtual data room and project context to draft the initial information request list. Use this when the list was skipped during project setup.',
    },
];

export const AI_REVIEW_SCOPES = ['Entire IRL', 'Information Technology', 'Cybersecurity', 'Open requests only', 'This IRL only'];

export const AI_SUGGESTED_RESPONSES = [
    {
        id: 'IRL-042',
        title: 'Provide the latest infrastructure migration plan',
        confidence: 'High',
        kind: 'full',
        body: 'Lens found evidence that appears to answer this request. The infrastructure migration plan (v3) was finalised in March 2026 and confirms Phase 1 is complete, Phase 2 is in progress with a December 2026 target, and Phase 3 is scheduled for Q1 2027 subject to board approval.',
        evidence: [
            { name: 'Migration Plan v3.pdf', path: 'IT → Infrastructure', page: 'p.12' },
            { name: 'Architecture Overview.pdf', path: 'p.12' },
        ],
    },
    {
        id: 'IRL-044',
        title: 'Provide evidence of DR testing',
        confidence: 'Medium',
        kind: 'partial',
        note: 'Lens found a partial answer.',
        answered: 'Annual testing requirement confirmed by policy document.',
        unresolved: 'No recent completed test report located. Most recent found: Sep 2023.',
    },
    {
        id: 'IRL-048',
        title: 'Provide penetration test results',
        confidence: 'Low',
        kind: 'none',
        note: 'Lens did not find sufficient evidence to answer this request.',
    },
    {
        id: 'IRL-045',
        title: 'Describe the cloud hosting strategy',
        confidence: 'High',
        kind: 'full',
        body: 'Lens found evidence that appears to answer this request. The infrastructure migration plan (v3) was finalised in March 2026 and confirms Phase 1 is complete, Phase 2 is in progress with a December 2026 target, and Phase 3 is scheduled for Q1 2027 subject to board approval.',
        evidence: [
            { name: 'Migration Plan v3.pdf', path: 'IT → Infrastructure', page: 'p.12' },
            { name: 'Architecture Overview.pdf', path: 'p.12' },
        ],
    },
    {
        id: 'IRL-047',
        title: 'Confirm data residency requirements',
        confidence: 'Medium',
        kind: 'partial',
        note: 'Lens found a partial answer.',
        answered: 'Annual testing requirement confirmed by policy document.',
        unresolved: 'No recent completed test report located. Most recent found: Sep 2023.',
    },
    {
        id: 'IRL-049',
        title: 'Describe ERP integration dependencies',
        confidence: 'Medium',
        kind: 'full',
        body: 'Lens found evidence that appears to answer this request. The infrastructure migration plan (v3) was finalised in March 2026 and confirms Phase 1 is complete, Phase 2 is in progress with a December 2026 target, and Phase 3 is scheduled for Q1 2027 subject to board approval.',
        evidence: [
            { name: 'Migration Plan v3.pdf', path: 'IT → Infrastructure', page: 'p.12' },
            { name: 'Architecture Overview.pdf', path: 'p.12' },
        ],
    },
];

export const AI_SUGGESTED_OBSERVATIONS = [
    {
        title: 'DR testing has not been performed within the annual window',
        materiality: 'High',
        confidence: 'High',
        body: 'Evidence reviewed across IRL responses and VDR documents indicates this observation is material to the project scope.',
    },
    {
        title: 'Cloud cost model lacks committed capacity reservation',
        materiality: 'Medium',
        confidence: 'Medium',
        body: 'Evidence reviewed across IRL responses and VDR documents indicates this observation is material to the project scope.',
    },
    {
        title: 'Penetration test scope excludes legacy ERP endpoints',
        materiality: 'High',
        confidence: 'Medium',
        body: 'Evidence reviewed across IRL responses and VDR documents indicates this observation is material to the project scope.',
    },
    {
        title: 'API governance framework is informal and undocumented',
        materiality: 'Low',
        confidence: 'High',
        body: 'Evidence reviewed across IRL responses and VDR documents indicates this observation is material to the project scope.',
    },
];

export const AI_SUGGESTED_FOLLOWUPS = [
    {
        parentId: 'IRL-042',
        title: 'Provide the most recent completed DR test report including recovery results',
        reason: 'Current response is incomplete or unsupported. A follow-up request would allow the respondent to provide the missing evidence.',
        related: {
            id: 'IRL-087',
            title: 'Provide the most recent completed DR test report, including recovery results',
        },
    },
    {
        parentId: 'IRL-044',
        title: 'Provide the test schedule for the next 12 months and confirm the last completion date',
        reason: 'Current response is incomplete or unsupported. A follow-up request would allow the respondent to provide the missing evidence.',
    },
    {
        parentId: 'IRL-045',
        title: 'Confirm current cloud vendor commitment and contract end dates',
        reason: 'Current response is incomplete or unsupported. A follow-up request would allow the respondent to provide the missing evidence.',
    },
];

export const AI_CONTRADICTIONS = [
    {
        leftLabel: 'IRL Response',
        left: 'IRL-044 Response: DR testing is performed annually.',
        rightLabel: 'Supporting evidence',
        right: 'Evidence: Most recent recovery test located is dated September 2023.',
        note: 'Lens does not determine which statement is correct. 2+ year gap observed.',
    },
    {
        leftLabel: 'IRL Response',
        left: 'IRL-047 Response: Data is held in Ireland under GDPR compliant arrangements.',
        rightLabel: 'Supporting evidence',
        right: 'Architecture Overview.pdf p.8: US-East-1 region referenced for analytics workloads.',
        note: 'Lens does not determine which statement is correct. Residency consistency requires confirmation.',
    },
];

export const IRL_HEADER_STATS = { open: 14, needsReview: 3, overdue: 2 };
export const OBS_HEADER_STATS = { confirmed: 18, mayNeedReview: 7, draft: 3 };

export function getIrlById(id) {
    return IRL_REQUESTS.find(item => item.id === id);
}

export function getObsById(id) {
    return OBSERVATIONS.find(item => item.id === id);
}

function workstreamCounts(requests) {
    const byId = new Map();
    requests.forEach(item => {
        if (item.workstreamId == null) return;
        const id = String(item.workstreamId);
        const current = byId.get(id) || {
            id,
            name: item.workstreamName || item.workstream,
            count: 0,
        };
        current.count += 1;
        byId.set(id, current);
    });
    if (byId.size === 0) {
        return WORKSTREAMS.map(ws => ({ ...ws, count: 0 }));
    }
    return Array.from(byId.values());
}

export function countIrlNav(requests) {
    return {
        all: requests.length,
        needsReview: requests.filter(item => item.status === 'Needs review').length,
        overdue: requests.filter(item => item.dueOverdue).length,
        workstreams: workstreamCounts(requests),
    };
}

export function countObsNav(observations, workstreams) {
    const rows = observations || [];
    const byId = new Map();
    rows.forEach(item => {
        if (item.workstreamId == null) return;
        const id = String(item.workstreamId);
        const current = byId.get(id) || {
            id,
            name: item.workstreamName || item.workstream,
            count: 0,
        };
        current.count += 1;
        byId.set(id, current);
    });
    let workstreamCounts = Array.from(byId.values());
    if (workstreamCounts.length === 0 && workstreams?.length) {
        workstreamCounts = workstreams.map(ws => ({ id: String(ws.id), name: ws.name, count: 0 }));
    }
    return {
        all: rows.length,
        mayNeedReview: rows.filter(item => item.freshness === 'New evidence' || item.freshness === 'Review required' || item.freshness === 'Potentially affected').length,
        draft: rows.filter(item => item.status === 'Draft').length,
        resolved: rows.filter(item => item.status === 'Resolved').length,
        workstreams: workstreamCounts,
    };
}
